module.exports = __webpack_public_path__ + "static/media/pix.3a41faaa.svg";